function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { NOT_APPLICABLE } from '../constants.js';
export const ratingsReviews = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('ratings-reviews.accordion-open', _ref => {
    let {
      output = {}
    } = _ref;
    const reviewSummaryDisplayed = output;
    const ddoEvent = {
      subContent: {
        component: 'accordion',
        section: 'zone-b',
        target: 'customer-reviews'
      }
    };
    if (reviewSummaryDisplayed === true) {
      ddoEvent.reviewSummaryDisplayed = true;
    }
    digitalData.event = digitalData.event || [];
    digitalData.event.push(_objectSpread({
      category: {
        primaryCategory: 'interaction'
      },
      eventInfo: {
        eventName: 'pip sub-content'
      }
    }, ddoEvent));
  });
  window.LIFE_CYCLE_EVENT_BUS.on('ratings-reviews.event', _ref2 => {
    let {
      output = {}
    } = _ref2;
    let componentName = '';
    let elementName = '';
    let moduleName = '';
    const {
      origin,
      location,
      value
    } = output;
    switch (location) {
      case 'search':
        {
          componentName = 'search reviews';
          elementName = NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'filter':
        {
          componentName = 'filter reviews';
          elementName = value || NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'writereview':
        {
          componentName = 'write a review';
          elementName = NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'writereviewoverlay':
        {
          componentName = 'write a review overlay';
          elementName = value || NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'keyword':
        {
          componentName = 'keyword';
          elementName = value;
          moduleName = origin;
          break;
        }
      case 'sort':
        {
          componentName = 'sort by';
          elementName = value;
          moduleName = origin;
          break;
        }
      case 'badge':
        {
          componentName = 'badge';
          elementName = NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'media':
        {
          componentName = 'media';
          elementName = value;
          moduleName = origin;
          break;
        }
      case 'readmore':
        {
          componentName = 'read more';
          elementName = NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'helpful':
        {
          componentName = 'was this helpful';
          elementName = value;
          moduleName = origin;
          break;
        }
      case 'profile':
        {
          componentName = 'profile';
          elementName = NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'pagination':
        {
          componentName = 'pagination';
          elementName = NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'review summary':
        {
          componentName = location;
          elementName = value;
          moduleName = origin;
          break;
        }
      case 'starrating':
        {
          componentName = 'star rating';
          elementName = NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'sentiment':
        {
          componentName = value;
          elementName = NOT_APPLICABLE;
          moduleName = origin;
          break;
        }
      case 'zone a':
        {
          componentName = value;
          elementName = NOT_APPLICABLE;
          moduleName = 'zone a';
          break;
        }
      default:
        {
          componentName = 'search reviews';
          elementName = NOT_APPLICABLE;
          moduleName = origin;
        }
    }
    digitalData.event = digitalData.event || [];
    digitalData.event.push({
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'ugc click'
      },
      content: {
        ugc: [{
          module: moduleName,
          component: componentName,
          element: elementName
        }]
      }
    });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('ratings-reviews.form-error', _ref3 => {
    let {
      output = {}
    } = _ref3;
    const {
      message,
      code
    } = output;
    digitalData.event = digitalData.event || [];
    digitalData.event.push({
      category: {
        primaryCategory: 'error'
      },
      eventInfo: {
        eventName: 'post page error',
        error: [{
          type: 'error',
          displayType: 'inline',
          pageSection: 'write a review',
          message,
          code
        }]
      }
    });
  });
};
//# sourceMappingURL=ratings-reviews.listener.analytics.js.map